import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { RoundBadge } from '@peacecover/component';
import { ArrowRightSmall, Attention } from '@peacecover/icon';
import { ReactComponent as PlusProfile } from '../../../icons/plus.profile.svg';

interface BettieUnfinishedChatRoomCardProps {
  balance: number;
}

const BettieUnfinishedChatRoomCard = ({ balance }: BettieUnfinishedChatRoomCardProps) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() =>
        navigate('/bettie-setting', {
          state: { initialStep: 'room_intro' }
        })
      }
      className="w-full bg-pure-white dark:bg-background-elevated dark:border dark:border-[#121212] rounded-[20px] shadow-[0_0_2px_0_rgba(0,0,0,0.05),_0_0_10px_0_rgba(0,0,0,0.08)] dark:shadow-[0_0_2px_0_rgba(0,0,0,0.83),_0_0_10px_0_rgba(0,0,0,0.40)]"
    >
      <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-surface-lv2">
        <div className="flex items-center gap-[4px]">
          <p className="text-[12px] font-medium leading-[14px] text-on-warning">
            {t('BettieChatList.unfinishedChatRoom')}
          </p>
          <Attention size={14} className="text-on-warning" />
        </div>
        {balance > 1 && <RoundBadge>+ {balance - 1}개</RoundBadge>}
      </div>
      <div className="flex items-center justify-between px-[20px] py-[15px]">
        <div className="flex items-center gap-[8px]">
          <PlusProfile width={48} height={48} />
          <div className="flex flex-col gap-[4px] items-start">
            <p className="text-[15px] font-semibold leading-[18px] text-text-main-lv2">
              {t('BettieChatList.settingChatRoom')}
            </p>
            <p className="text-[13px] leading-[16px] text-text-main-lv3">
              {t('BettieChatList.startConversation')}
            </p>
          </div>
        </div>
        <ArrowRightSmall size={20} className="text-text-main-lv3" />
      </div>
    </button>
  );
};

export default BettieUnfinishedChatRoomCard;


